<div *ngIf="data?.itinerary" class="bg-white">
  <p>{{ data.itinerary.title }}</p>

  <div class="py-4 px-8 overflow-y-auto max-h-[70vh]">
    @for (attraction of data.itinerary.attractions; let i = $index; track i) {
      <div class="border-l-[1px] border-dashed border-gray-300 pl-7 relative mt-6">
        <div class="translate-x-[-43px] absolute">
          <div
            class="w-7 h-7 rounded-full bg-gray-300 font-semibold flex items-center justify-center">{{ i + 1 }}
          </div>
        </div>

        <div class="flex flex-col">
          <b class="text-blue-600">{{ attraction.item.name }}</b>
          <div class="flex flex-col text-sm gap-4">
            <div class="flex">
              <div class="min-w-[150px]">
                <b>Pre-description:</b>
                <p *ngIf="isJustGenerated(attraction.item._id, 'pre')" class="text-sm text-green-500">Just generated</p>
              </div>
              <mat-icon
                class="min-w-[24px] rounded-full text-sm !flex justify-center items-center text-white bg-gray-800 absolute -right-5 cursor-pointer"
                matTooltip="Edit" (click)="edit(attraction, 'pre')" [matMenuTriggerFor]="editMenu"
                #editMenuTrigger="matMenuTrigger">edit
              </mat-icon>
              <span>{{ attraction.preDescription }}</span>
            </div>
            <div class="flex">
              <div class="min-w-[150px]">
                <b>Description:</b>
                <p *ngIf="isJustGenerated(attraction.item._id, 'desc')" class="text-sm text-green-500">Just
                  generated</p>
              </div>
              <mat-icon
                class="min-w-[24px] rounded-full text-sm !flex justify-center items-center text-white bg-gray-800 absolute -right-5 cursor-pointer"
                matTooltip="Edit" (click)="edit(attraction, 'desc')" [matMenuTriggerFor]="editMenu"
                #editMenuTrigger="matMenuTrigger">edit
              </mat-icon>
              <span>{{ attraction.item.description }}</span>
            </div>
            <div class="flex">
              <div class="min-w-[150px]">
                <b>Post-description:</b>
                <p *ngIf="isJustGenerated(attraction.item._id, 'post')" class="text-sm text-green-500">Just
                  generated</p>
              </div>
              <mat-icon
                class="min-w-[24px] rounded-full text-sm !flex justify-center items-center text-white bg-gray-800 absolute -right-5 cursor-pointer"
                matTooltip="Edit" (click)="edit(attraction, 'post')" [matMenuTriggerFor]="editMenu"
                #editMenuTrigger="matMenuTrigger">edit
              </mat-icon>
              <span>{{ attraction.postDescription }}</span>
            </div>

            <mat-menu #editMenu="matMenu"
                      class="ig-text-color-edit ig-iti-desc-editor !rounded-md px-6 py-2">
              <div igClickStopPropagation>
                <p class="!mb-3 font-semibold">{{ getEditingTitle() }}</p>
                <ig-field mode="textarea" [control]="form.get('text')"
                          label="Text content" [maxlength]="4000"
                          icon="title"></ig-field>
                <!--                <p class="text-blue-600 underline cursor-pointer text-right mt-2" (click)="setText()">OK</p>-->
                <div class="flex justify-end">
                  <ig-button (trigger)="setText()">OK</ig-button>
                </div>
              </div>
            </mat-menu>
          </div>
        </div>
      </div>
    }
  </div>

  <div class="flex justify-end">
    <ig-button (trigger)="save($event)" [isAsync]="true" successText="All descriptions saved!" cls="w-[120px] mt-5">
      SAVE
    </ig-button>
  </div>
</div>
